(function () {
  function getSelectedBundlePrice() {
    const selected = document.querySelector('.ia-card--selected .ia-card-price');
    if (selected) return selected.textContent.trim();
    const first = document.querySelector('.ia-card .ia-card-price');
    return first ? first.textContent.trim() : null;
  }

  function syncButtonPrice() {
    const price = getSelectedBundlePrice();
    if (!price) return;
    document.querySelectorAll('.product-form__submit-price').forEach(function (el) {
      if (el.textContent.trim() !== price) {
        el.textContent = price;
      }
    });
  }

  function init() {
    const container = document.querySelector('.oxify-bundle-set-parent-div, [class*="oxify"][class*="bundle"]');
    if (!container) {
      // Bundle picker not on this page — leave the static variant price in place.
      return;
    }

    syncButtonPrice();

    // 1) Listen for clicks on any bundle card (radios are inside the cards).
    container.addEventListener('click', function () {
      setTimeout(syncButtonPrice, 50);
      setTimeout(syncButtonPrice, 200);
    });

    // 2) Watch for class changes on cards (Oxify toggles `ia-card--selected`).
    const observer = new MutationObserver(function () {
      syncButtonPrice();
    });
    container.querySelectorAll('.ia-card').forEach(function (card) {
      observer.observe(card, { attributes: true, attributeFilter: ['class'] });
    });

    // 3) Re-check shortly after load in case Oxify renders the picker late.
    setTimeout(syncButtonPrice, 500);
    setTimeout(syncButtonPrice, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
